// image-processing-loader
var previousRequest = require("!!../../../../../../node_modules/fox-file-loader/index.js!../../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./bi-join-banner.jpg");
var dir = previousRequest.replace("bi-join-banner.jpg", "")
module.exports = require("!../../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "bi-join-banner.jpg",
	name: "bi-join-banner",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/bg/bi-join-banner.jpg
// module id = 1004
// module chunks = 4